import {
    GET_COLLECTIONS_REQUEST,
    GET_COLLECTIONS_SUCCESS,
    GET_COLLECTIONS_FAILED,
    GET_COLLECTIONS_BY_LOAN_REQUEST,
    GET_COLLECTIONS_BY_LOAN_SUCCESS,
    GET_COLLECTIONS_BY_LOAN_FAILED,
    CREATE_COLLECTION_REQUEST,
    CREATE_COLLECTION_SUCCESS,
    CREATE_COLLECTION_FAILED,
    UPDATE_COLLECTION_CARD_STATUS_REQUEST,
    UPDATE_COLLECTION_CARD_STATUS_SUCCESS,
    UPDATE_COLLECTION_CARD_STATUS_FAILED,
    UPDATE_COLLECTION_CHARGES_REQUEST,
    UPDATE_COLLECTION_CHARGES_SUCCESS,
    UPDATE_COLLECTION_CHARGES_FAILED,
    CLEAR_COLLECTION_ERRORS,
    RESET_COLLECTION_SUCCESS,
} from '../actions/CollectionsActions';

const initialState = {
    listdata: [],
    pagination: {},
    currentLoanCollections: [],
    loading: false,
    error: null,
    validationErrors: null,
    success: false,
};

const CollectionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_COLLECTIONS_REQUEST:
        case GET_COLLECTIONS_BY_LOAN_REQUEST:
        case CREATE_COLLECTION_REQUEST:
        case UPDATE_COLLECTION_CARD_STATUS_REQUEST:
        case UPDATE_COLLECTION_CHARGES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                success: false,
            };

        case GET_COLLECTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                listdata: action.payload.data || [],
                pagination: action.payload.pagination || {},
                error: null,
            };

        case GET_COLLECTIONS_BY_LOAN_SUCCESS:
            return {
                ...state,
                loading: false,
                currentLoanCollections: action.payload.data || [],
                pagination: action.payload.pagination || {},
                error: null,
            };

        case CREATE_COLLECTION_SUCCESS:
        case UPDATE_COLLECTION_CARD_STATUS_SUCCESS:
        case UPDATE_COLLECTION_CHARGES_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                error: null,
            };

        case GET_COLLECTIONS_FAILED:
        case GET_COLLECTIONS_BY_LOAN_FAILED:
        case CREATE_COLLECTION_FAILED:
        case UPDATE_COLLECTION_CARD_STATUS_FAILED:
        case UPDATE_COLLECTION_CHARGES_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                validationErrors: action.payload?.errors || null,
            };

        case CLEAR_COLLECTION_ERRORS:
            return {
                ...state,
                error: null,
                validationErrors: null,
            };

        case RESET_COLLECTION_SUCCESS:
            return {
                ...state,
                success: false,
            };

        default:
            return state;
    }
};

export default CollectionsReducer;
